<template>
  <div>
    <div class="profession-counters-container">
      <div class="professions-counter"
           v-for="profession in teamProfessionsCache"
           :key="profession.professionId">
        <ItemsCounter :maxCount="profession.maxWorkerCount"
                      :count="getWorkersCountForProfession(profession)"
                      :label="profession.professionName"/>
      </div>
    </div>

    <SelectDropDown class="professions-dropdown"
                    :id="'selectProfession'"
                    v-if="!isTeamLoading && defaultSelectedProfession"
                    :options="teamProfessionsCache"
                    :defaultSelected="defaultSelectedProfession"
                    :label="'Филтриране по професия'"
                    :selector="'professionName'"
                    @selection-change="professionSelected"
                    :name="'selectProfession'"/>

    <div class="profession-counters-container">
      <h2 class="team-edit-subtitle" style="float: left; color: var(--primary-blue);">Състав на екипа</h2>
      <h2 class="team-edit-subtitle" style="float: right; color: var(--primary-green);">Добавяне към екипа</h2>
    </div>

    <Grid class="grid-team-edit"
          :config="removeConfig"
          :gridData="teamMemberList"
          :loading="isTeamLoading"
          style="float: left;"
          @row-clicked="removeRowClicked">
    </Grid>

    <Grid class="grid-team-edit"
          :config="addConfig"
          :gridData="workersNotInTheTeam"
          :loading="isTeamLoading"
          style="float: right;"
          @row-clicked="addRowClicked">
    </Grid>

    <Button class="save-edit-team-members-button"
            @click.native="saveTeamMembers"
            :color="'green'"
            :text="'Запази'"
            :icon="'fa fa-save'"/>
  </div>
</template>

<script>
import Grid from "@/shared/components/grid/Grid";
import teamMembersGridConfig from "@/components/team/form/team-members-list-grid.config";
import {mapGetters} from "vuex";
import {cloneDeep} from 'lodash';
import workerService from "@/services/worker.service";
import utilService from "@/services/util.service";
import SelectDropDown from "@/shared/components/form/SelectDropDown";
import Button from "@/shared/components/button/Button";
import teamService from "@/services/team.service";
import ItemsCounter from "@/shared/components/ItemsCounter";

export default {
  name: "TeamMembersEditForm",
  components: {ItemsCounter, Button, SelectDropDown, Grid},
  created() {
    this.teamMemberList = this.getTeamMemberList();
    workerService.fetchWorkers()
        .then(({data}) => this.allWorkers = data);
    this.teamProfessionsCache = this.getTeamProfessions();
    this.defaultSelectedProfession = this.teamProfessions ? this.teamProfessions[0] : null;
  },
  data() {
    return {
      teamId: this.$route.params.id,
      config: teamMembersGridConfig,
      teamMemberList: this.getTeamMemberList(),
      allWorkers: [],
      defaultSelectedProfession: this.teamProfessions ? this.teamProfessions[0] : null,
      teamProfessionsCache: this.teamProfessions
    }
  },
  methods: {
    addRowClicked(row) {
      row.workerId = row.id;
      row.professionId = this.defaultSelectedProfession.professionId;
      row.professionName = this.defaultSelectedProfession.professionName;
      row.professionOrderIndex = this.defaultSelectedProfession.professionOrderIndex;
      this.teamMemberList.push(row);
      this.teamMemberList = utilService.sortArrayByNumberSelector(this.teamMemberList, 'professionOrderIndex', true);
    },
    removeRowClicked(row) {
      this.teamMemberList = this.teamMemberList.filter((teamMember) => teamMember.workerId !== row.workerId);
    },
    getTeamMemberList() {
      if (this.teamMembers && !this.isTeamLoading) {
        const arrayTemp = cloneDeep(this.teamMembers).map((teamMember) => {
          teamMember.id = teamMember.workerId;
          return teamMember;
        });
        return utilService.sortArrayByNumberSelector(arrayTemp, 'professionOrderIndex', true);
      }
      return [];
    },
    getTeamProfessions() {
      return this.teamProfessions.map((teamProfession) => {
        teamProfession.id = teamProfession.professionId;
        return teamProfession;
      });
    },
    professionSelected(profession) {
      this.defaultSelectedProfession = profession.currentValue;
    },
    saveTeamMembers() {
      teamService.updateMembers(this.teamId, this.teamMemberList)
          .then(({data}) => {
            this.$store.commit('setTeamMembers', data);
            this.$store.dispatch('fetchTeam', this.teamId);
            this.$emit('saved-successful');
          });
    },
    getWorkersCountForProfession(profession) {
      return this.teamMemberList.filter((teamMember) => teamMember.professionId === profession.professionId).length;
    }
  },
  computed: {
    ...mapGetters(['teamMembers', 'isTeamLoading', 'teamProfessions']),

    addConfig() {
      const temp = cloneDeep(teamMembersGridConfig);
      temp.props.tableHeight = 400;
      temp.columns = temp.columns.filter((column) => column.selector !== 'professionName');
      temp.props.selectableColumn.icon = 'fa fa-plus';
      return temp;
    },
    removeConfig() {
      const temp = cloneDeep(teamMembersGridConfig);
      temp.props.tableHeight = 400;
      temp.props.selectableColumn.icon = 'fa fa-minus';
      return temp;
    },
    workersNotInTheTeam() {
      const idsInTeam = this.teamMemberList.map((teamMember) => teamMember.workerId);
      return this.allWorkers
          // filter workers to show those that are not in the team
          .filter((worker) => !idsInTeam.includes(worker.id))
          // filter workers by selected professions
          .filter((worker) => worker.professions.map((profession) => profession.id).includes(this.defaultSelectedProfession.professionId));
    }
  },
  watch: {
    teamMembers: {
      handler() {
        this.teamMemberList = this.getTeamMemberList();
      },
      deep: true
    },
    teamProfessions: {
      handler(newVal) {
        this.teamProfessionsCache = this.getTeamProfessions();
        this.defaultSelectedProfession = newVal[0];
      },
      deep: true
    }
  }
}
</script>

<style scoped>
@import '../../../css/shared/tabs.css';

.grid-team-edit {
  margin-top: 20px;
  margin-bottom: 50px;
  display: inline-block;
  width: 48%;
}

.professions-dropdown {
  width: 40%;
  float: right;
  display: inline-block;
  margin: 25px 4% 0 auto;
}

.save-edit-team-members-button {
  width: 400px;
  height: 60px;
  margin: 20px auto;
  display: inline-block;
  font-size: 25px;
}

.professions-counter {
  width: fit-content;
  display: inline-block;
  margin: 20px;
  font-size: 22px;
}

.profession-counters-container {
  width: 100%;
  display: inline-block;
}

.team-edit-subtitle {
  width: 48%;
  margin-top: 30px;
  display: inline-block;
}

</style>
